import { useEffect, useState } from 'react';
import CropImage from './cropImage';
import apiServices from '../../../services/service';
import Popup from '../popup';
import { useLocation } from 'react-router-dom';
import Tags from '../tags';
import pricesheetImg from '../../../../src/assets/img/crm_home/sidemenu/master.svg';

const HeaderProfileBlock = ({ moduleName, localData, uploadFile, View }) => {
  const [imageUrl, setImageUrl] = useState('/assets/images/crm/add-image-placeholder.svg');
  const [showPopup, setShowPopup] = useState(false);
  const [blobExists, setBlobExists] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showTagPopover, setShowTagPopover] = useState(false);

  const location = useLocation();
  const [staticImg, setStaticImg] = useState('');

  const handleShowTagPopover = () => {
    setShowTagPopover(true);
  };
  const handleCloseTagPopover = () => {
    setShowTagPopover(false);
  };

  const handleSave = (Blob) => {
    uploadFile(Blob);
    const croppedImageUrl = URL.createObjectURL(Blob);
    setImageUrl(croppedImageUrl);
    setShowPopup(false);
  };

  const handleClose = () => {
    setShowPopup(false);
  };
  // Fetch image if localData is not in "add" mode
  useEffect(() => {
    if (localData?.id) {
      setLoading(true);
      apiServices
        .getLeadImageCRM(`${moduleName}/${localData?.id}`)
        .then((url) => {
          setImageUrl(url);
          setBlobExists(true);
        })
        .catch(() => {
          setBlobExists(false);
        })
        .finally(() => setLoading(false));
    }
  }, [localData?.id]);

  const shouldUploadImage = ['lead', 'account', 'contact'].some((keyword) =>
    location.pathname.includes(keyword)
  );

  useEffect(() => {
    const pathname = location.pathname;
    const iconMap = {
      opportunity: '/assets/images/crm/headerIcons/opportunity.png',
      ticket: '/assets/images/crm/headerIcons/tasks.png',
      campaign: '/assets/images/crm/headerIcons/camp.png',
      meetings: '/assets/images/crm/headerIcons/meetings.png',
      calls: '/assets/images/crm/headerIcons/calls.png',
      quoteAI: '/assets/images/crm/headerIcons/tasks.png',
      sales: '/assets/images/crm/headerIcons/Sales.svg',
      invoice: '/assets/images/crm/headerIcons/invoice.svg',
      productList: pricesheetImg,
      priceSheet: pricesheetImg,
    };

    const matchedKey = Object.keys(iconMap).find((key) => pathname.includes(key));

    if (matchedKey) {
      setStaticImg(iconMap[matchedKey]);
    }
  }, [location.pathname]);

  return (
    <>
      <div className="userProfileBlock">
        <div
          className="userimg"
          onClick={() => setShowPopup(true)}
          style={{ cursor: shouldUploadImage ? 'pointer' : 'default' }}
        >
          {shouldUploadImage ? (
            <img src={imageUrl} alt="" title=""></img>
          ) : (
            <img src={staticImg} alt="" title=""></img>
          )}
        </div>

        <div>
          <p>
            {localData?.fullName
              ? localData.fullName
              : localData?.name
                ? localData.name
                : localData?.subject
                  ? localData.subject
                  : localData?.campaignName
                    ? localData.campaignName
                    : localData?.sequenceName
                      ? localData.sequenceName
                      : 'Create New ' + moduleName}

            {/* {localData?.fullName
              ? localData.fullName
              : localData?.type === 'add'
                ? `Create New ${moduleName}`
                : localData?.type === 'edit' || localData?.type === 'view'
                  ? localData?.subject?.trim()
                    ? localData.subject
                    : localData?.campaignName?.trim()
                      ? localData.campaignName
                      : localData?.name?.trim()
                        ? localData.name
                        : ''
                  : ''} */}
          </p>

          {View &&
            moduleName !== 'Ticket' &&
            moduleName !== 'Quotes' &&
            moduleName !== 'Sales' &&
            moduleName !== 'Invoice' &&
            moduleName !== 'Product' &&
            moduleName !== 'PriceSheet' && <Tags localData={localData} module={moduleName} />}
        </div>

        {showPopup && !View && shouldUploadImage && (
          <Popup heading={'Upload Image'} handleClose={handleClose}>
            {uploadFile && (
              <CropImage handleSave={handleSave} defaultImg={imageUrl} handleClose={handleClose} />
            )}
          </Popup>
        )}
      </div>
    </>
  );
};

export default HeaderProfileBlock;
